import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { IQuoteState } from '../models';
import { QuoteState } from './quote.state';

@Injectable({ providedIn: 'root' })
export class QuoteSelector {
  @Selector([QuoteState])
  static analyticsParams(
    quoteState: IQuoteState
  ): Record<string, string> | undefined {
    return quoteState.analytics;
  }
}
